module.exports = __webpack_public_path__ + "img/resume_thumbnail-1.3503ff78.jpg";